import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { pipe, compose, curry, propEq, filter, pluck, uniq, map, pick, reduce, maxBy, minBy, prop } from "ramda";
import { sortMeasurementsByPeriod } from "utils/sort/sort";
import { dateConvertKeys } from "utils/dates";
import { calculateRelativeToValue } from "utils/measurement/measurementExtensions";
import { isEmptyObject } from "utils/validation";
export var measurementsParams = pick(["measureIds", "units", "periodType", "dateFrom", "dateTo", "gender"]);
var byPeriodMax = function byPeriodMax(x) {
  var _x$period, _x$period$end;
  return (x === null || x === void 0 ? void 0 : (_x$period = x.period) === null || _x$period === void 0 ? void 0 : (_x$period$end = _x$period.end) === null || _x$period$end === void 0 ? void 0 : _x$period$end.getTime()) || -Infinity;
};
var byPeriodMin = function byPeriodMin(x) {
  var _x$period2, _x$period2$start;
  return (x === null || x === void 0 ? void 0 : (_x$period2 = x.period) === null || _x$period2 === void 0 ? void 0 : (_x$period2$start = _x$period2.start) === null || _x$period2$start === void 0 ? void 0 : _x$period2$start.getTime()) || Infinity;
};
export var dateConvertMeasurements = function dateConvertMeasurements(measurements) {
  return _toConsumableArray(measurements).map(function (x) {
    return _objectSpread(_objectSpread({}, x), {}, {
      period: dateConvertKeys(["start", "end"], x.period)
    });
  });
};
export var cleanMeasurements = compose(sortMeasurementsByPeriod, dateConvertMeasurements);
export var adjustQueryToMeasurementsWithMetadata = function adjustQueryToMeasurementsWithMetadata(query, measurementsWithMetadata) {
  var _earliestValue$period, _latestValue$period;
  var flattendMeasurements = measurementsWithMetadata.map(prop("measurements")).flat();
  var latestValue = reduce(maxBy(byPeriodMax), null, flattendMeasurements);
  var earliestValue = reduce(minBy(byPeriodMin), null, flattendMeasurements);
  return _objectSpread(_objectSpread({}, query), {}, {
    periodType: latestValue === null || latestValue === void 0 ? void 0 : latestValue.periodType,
    dateFrom: (earliestValue === null || earliestValue === void 0 ? void 0 : (_earliestValue$period = earliestValue.period) === null || _earliestValue$period === void 0 ? void 0 : _earliestValue$period.start) || query.dateFrom,
    dateTo: (latestValue === null || latestValue === void 0 ? void 0 : (_latestValue$period = latestValue.period) === null || _latestValue$period === void 0 ? void 0 : _latestValue$period.end) || query.dateTo
  });
};
export var getActiveSubmeasures = function getActiveSubmeasures(measurementsWithMetadata, measure) {
  return pipe(uniq, map(function (id) {
    var _measure$submeasures;
    return measure === null || measure === void 0 ? void 0 : (_measure$submeasures = measure.submeasures) === null || _measure$submeasures === void 0 ? void 0 : _measure$submeasures.find(propEq("measureId", id));
  }), filter(Boolean))(pluck("measureId", measurementsWithMetadata));
};
export var applyFuncToMeasurementsWithMetadata = function applyFuncToMeasurementsWithMetadata(func, mappedMeasurementsWithMetadata) {
  var map = new Map();
  mappedMeasurementsWithMetadata.forEach(function (measurementsWithMetadata, key) {
    map.set(key, measurementsWithMetadata.map(func));
  });
  return map;
};
export var addRelativeToToMeasurementsWithMetadata = curry(function (lookupParentMeasure, mappedMeasurementsWithMetadata) {
  return applyFuncToMeasurementsWithMetadata(function (measurementWithMetadata) {
    return _objectSpread(_objectSpread({}, measurementWithMetadata), {}, {
      measurements: measurementWithMetadata.measurements.map(function (measurement) {
        var _mappedMeasurementsWi;
        return _objectSpread(_objectSpread({}, measurement), {}, {
          relativeTo: calculateRelativeToValue(lookupParentMeasure(measurementWithMetadata.parentId), (_mappedMeasurementsWi = mappedMeasurementsWithMetadata.get("".concat(measurementWithMetadata.parentId, "-SE"))) === null || _mappedMeasurementsWi === void 0 ? void 0 : _mappedMeasurementsWi.find(propEq("measureId", measurementWithMetadata.measureId)), measurement)
        });
      })
    });
  }, mappedMeasurementsWithMetadata);
});

//Builds a map of measurementsWithMetadata to make them easily accessable by parentId-organizationId
export var createMeasurementsWithMetadataMap = function createMeasurementsWithMetadataMap(measurementsWithMetadata) {
  var map = new Map();
  measurementsWithMetadata.forEach(function (x) {
    if (x.measurements) {
      var newEntry = _objectSpread(_objectSpread({}, x), {}, {
        measurements: cleanMeasurements(x.measurements)
      });
      if (map.get("".concat(x.parentId, "-").concat(x.organizationId))) {
        map.set("".concat(x.parentId, "-").concat(x.organizationId), [newEntry].concat(_toConsumableArray(map.get("".concat(x.parentId, "-").concat(x.organizationId)))));
      } else map.set("".concat(x.parentId, "-").concat(x.organizationId), [newEntry]);
    }
  });
  return map;
};

//Needs to be run before mapIsExpanded with singular parentId + organizationId
export var removeReichFromMeasurementsWithMetadataMap = function removeReichFromMeasurementsWithMetadataMap(mappedMeasurementsWithMetadata) {
  var newMap = new Map(mappedMeasurementsWithMetadata);
  mappedMeasurementsWithMetadata.forEach(function (x, key) {
    return x[0].organizationId === "SE" && newMap.delete(key);
  });
  return newMap;
};

//Expands original parentId-organizationId map to also include parentId and organizationId as own entries
export var expandMeasurementsMap = function expandMeasurementsMap(mappedMeasurementsWithMetadata) {
  var newMap = new Map(mappedMeasurementsWithMetadata);
  mappedMeasurementsWithMetadata.forEach(function (x) {
    //directlink to everything by parentId
    if (newMap.get(x[0].parentId)) newMap.set(x[0].parentId, [].concat(_toConsumableArray(x), _toConsumableArray(newMap.get(x[0].parentId))));else newMap.set(x[0].parentId, x);

    //directlink to everything in organizationId
    if (newMap.get(x[0].organizationId)) newMap.set(x[0].organizationId, [].concat(_toConsumableArray(x), _toConsumableArray(newMap.get(x[0].organizationId))));else newMap.set(x[0].organizationId, x);
  });
  return newMap;
};

//Goto method for formatting measurementsWithMetadata after they've been fetched from BE
export var cleanAndMapifyMeasurementsWithMetadata = function cleanAndMapifyMeasurementsWithMetadata(_query, lookupParentMeasure, measurementsWithMetadata) {
  if (isEmptyObject(_query)) return new Map();
  var removeReich = !_query.units.includes("SE");
  return pipe(createMeasurementsWithMetadataMap, addRelativeToToMeasurementsWithMetadata(lookupParentMeasure), function (x) {
    return removeReich ? removeReichFromMeasurementsWithMetadataMap(x) : x;
  }, expandMeasurementsMap)(measurementsWithMetadata);
};